module.exports = __webpack_public_path__ + "img/b2b03.3b52697d.png";